module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_agder_neg.f9e9273e.svg";